<template lang="html">
  <div class="check-list text-left w-100 mb-3">
    <div v-if="title" class="mb-1">{{ title }}</div>
    <div
      v-for="option in options"
      :key="option.slug"
      @click="option.active = !option.active"
      class="option d-flex align-items-start"
    >
      <i v-if="option.active" class="far fa-check-square mr-2"></i>
      <i v-else class="far fa-square mr-2"></i>
      <div class="ml-1">{{ option.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'options',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    responsive: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.option {
  cursor: pointer;
  line-height: 1.2rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  @media screen and (max-width: $breakpoint-sm) {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  &:hover {
    background-color: var(--highlight);
  }

  .far {
    margin-top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/Checklist.vue